import classNames from 'classnames'
import React from 'react'

import { GlobalSearchResultsItem } from '../../../../../../types/responses/global-search'
import ContactSearchResults from './ContactSearchResults/ContactSearchResults'
import NoResultsMessage from './NoResultsMessage'

interface Props {
  searchResults: GlobalSearchResultsItem
  isFetching: boolean
}

const SearchResults: React.FC<Props> = ({ searchResults, isFetching }) => {
  const { contacts, totalItems } = searchResults

  if (totalItems === 0 && !isFetching) {
    return <NoResultsMessage />
  }

  return (
    <div
      className={classNames('d-flex flex-column gap-4', {
        'opacity-75': isFetching,
      })}
    >
      <ContactSearchResults searchResults={contacts} />
    </div>
  )
}

export default SearchResults
